import { Box } from "@chakra-ui/react"

export default function Spacer() {
    return <Box w="100%" />
}
